import React from 'react'
import useStyles from './_styles'
import { PageBodyProps } from './_props'

const PageContentBody = ({ children }: PageBodyProps) => {
    const classes = useStyles()
    return <div className={classes.PageContentBody}>{children}</div>
}

export default PageContentBody
